export const COOKIE_NAMES = {
     TP_IS_LOGGED_IN: 'tp_isLoggedIn',
     FAST_TEST: '__fast-test__',
     FEATURE_FLAG: '__feature-flag__',
     TEST_SOW_ORDER_ENABLED: '__test-sow-order-enabled__',
     SOW_ORDER_ENABLED: '__sow-order-enabled__',
     CURRENT_USER: '__current-user__',
     ORGANIZATION_USER: '__organization-user__',
};

export const COOKIE_PARAMS = {
     FAST_TESTING: 'fast-testing',
     FEATURE_FLAG: 'feature-flag',
     TEST_SOW_ORDER_ENABLED: 'test-sow-order-enabled',
     SOW_ORDER_ENABLED: 'sow-order-enabled',
};
